import products from './products';
import suppliers from './suppliers';
import sells from './sells';

export default { products, suppliers, sells };
